import apiClient from './client';

/**
 * Records a positive or negative user emotion for a video.
 * @param musicVideo
 * @param heartVideo
 */
export async function writeActorEmotion(
  musicVideo: string,
  heartVideo: boolean
): Promise<void> {
  await apiClient.post(
    `/secure/actor/emotion/${encodeURIComponent(musicVideo)}/${heartVideo ? 'positive' : 'negative'}`,
    {},
  );
}
